import { ApiError } from '../../api';

export const errorText = (e: unknown, fallback: string) => (e instanceof ApiError ? (e.status === 422 ? (Object.values(e.fields)[0] ?? e.message) : e.message) : fallback);

const dayFormat = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Berlin' });
export const formatDay = (iso: string | null) => (iso ? dayFormat.format(new Date(`${iso.slice(0, 10)}T12:00:00`)) : '–');
const monthFormat = new Intl.DateTimeFormat('de-DE', { month: 'long', year: 'numeric', timeZone: 'UTC' });
export const monthText = (month: string) => monthFormat.format(new Date(`${month}-15T12:00:00Z`));
export const percentText = (bp: number | null) => (bp === null ? '–' : `${(bp / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} %`);
